import { SUPPORTED_LNGS } from '@/i18n'

export function shouldSyncChromeLocale(
  locale: string | null,
  currentI18nLanguage: string,
  supported: readonly string[] = SUPPORTED_LNGS,
): string | null {
  const code = (locale ?? '').trim()
  if (!code || !supported.includes(code)) return null
  const current = (currentI18nLanguage || '').split('-')[0]
  if (current === code) return null
  return code
}
